export default __webpack_public_path__ + "static/front-2b522824cf8856530202e18d0a6a660b.jpg";